<template>
  <div class="tableBox11">
    <div class="box11Title">隐患治理</div>
    <el-table
      :data="tableData"
      border
      style="width: 98%;margin: auto; height: 243px"
      :header-cell-style="{padding: '9px 3px'}"
      :cell-style="{padding: '8px 3px'}"
    >
      <el-table-column prop="num" label="编号" width="120" />
      <el-table-column prop="hdName" label="隐患名称" min-width="160" />
      <el-table-column prop="level" label="级别" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="getLevelType(row.level)">{{ getLevelText(row.level) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="getStatusType(row.status)">{{ getStatusText(row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="checkTime" label="检查时间" min-width="170">
        <template slot-scope="{ row }">
          {{ formatTime(row.checkTime) }}
        </template>
      </el-table-column>
    </el-table>
    <div class="expireBox">
      <el-pagination
        small
        layout="prev, pager, next"
        @current-change="handleChange"
        :total="total"
        :page-size="limit"
        :current-page="curPage"
      />
    </div>
  </div>
</template>

<script>
import { getHiddenGovernList } from "@/api/earlyWarning"

export default {
  name: "hiddenGovern",
  data() {
    return {
      tableData: [],
      total: 0,
      limit: 5,
      curPage: 1
    }
  },
  methods: {
    getList() {
      getHiddenGovernList({ limit: this.limit, curPage: this.curPage, alarmOnly: 1 }).then(res => {
        this.tableData = Array.isArray(res.body && res.body.data) ? res.body.data : []
        this.total = Number(res.body && res.body.cum ? res.body.cum : 0)
      })
    },
    handleChange(val) {
      this.curPage = val
      this.getList()
    },
    formatTime(value) {
      return value || '--'
    },
    getLevelText(level) {
      if (level === 1 || level === '1') {
        return '重大隐患'
      }
      if (level === 0 || level === '0') {
        return '一般隐患'
      }
      return '--'
    },
    getLevelType(level) {
      if (level === 1 || level === '1') {
        return 'danger'
      }
      if (level === 0 || level === '0') {
        return 'warning'
      }
      return 'info'
    },
    getStatusText(status) {
      if (status === 0 || status === '0') {
        return '已创建'
      }
      if (status === 1 || status === '1') {
        return '待审批'
      }
      if (status === 2 || status === '2') {
        return '待整改'
      }
      if (status === 3 || status === '3') {
        return '待复核'
      }
      if (status === 4 || status === '4') {
        return '已完成'
      }
      return '--'
    },
    getStatusType(status) {
      if (status === 0 || status === '0') {
        return 'info'
      }
      if (status === 1 || status === '1') {
        return 'warning'
      }
      if (status === 2 || status === '2') {
        return 'danger'
      }
      if (status === 3 || status === '3') {
        return 'warning'
      }
      if (status === 4 || status === '4') {
        return 'success'
      }
      return 'info'
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
.tableBox11 {
  width: 49%;
  height: 300px;
  border: 1px solid rgb(232, 232, 232);
  margin-right: 1%;
  margin-bottom: 10px;
}

.box11Title {
  padding-left: 8px;
  font-weight: 600;
}

.expireBox {
  text-align: right;
  margin-top: 3px;
}
</style>
